import { render, staticRenderFns } from "./UserAppsList.vue?vue&type=template&id=63f49259&scoped=true&"
import script from "./UserAppsList.vue?vue&type=script&lang=ts&"
export * from "./UserAppsList.vue?vue&type=script&lang=ts&"
import style0 from "./UserAppsList.vue?vue&type=style&index=0&id=63f49259&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f49259",
  null
  
)

export default component.exports